import { useSelector, useDispatch } from 'react-redux';
import FJMobileDefaultPreview from '../FJMainPreview/FJMobileDefaultPreview/FJMobileDefaultPreview';
import FJActionImageExtender from '../../redux/action/FJActionImageExtender';
import FJMobileImageExtenderEditContainer from './FJMobileImageExtenderEdit/FJMobileImageExtenderEditContainer';
import FJMobileImageExtenderCreationContainer from './FJMobileImageExtenderCreation/FJMobileImageExtenderCreationContainer';
import { useCallback, useEffect } from 'react';
import FJMobileGenerateSuccessfulContainer from '../FJMainPreview/FJMobileGenerateSuccessful/FJMobileGenerateSuccessfulContainer';
import { setSliceMobileGenerateSuccessPreviewIndex, setSliceTaskStatusAction } from '../../redux/slices/FJSliceCommon';
import FJLocalStore from '../../store/FJLocalStore';
import FJConstant from '../../constants/FJConstant';
import FJConfig from '../../config/FJConfig';
import FJMobileHistoryContainer from '../FJMainPreview/FJMobileHistory/FJMobileHistoryContainer';
import useLocalStore from '../../hooks/useLocalStore';
const FJMobileImageExtender = () => {
    const dispatch = useDispatch();
    useLocalStore();

    const creationList = useSelector(state => state.common.creationList);
    const uploadImageInfo = useSelector(state => state.imageExtender.uploadImageInfo);
    const boardSize = useSelector(state => state.imageExtender.boardSize);

    useEffect(() => {
        dispatch(FJActionImageExtender.initImageExtenderDataAction());
    }, [dispatch]);
    const uploadImg = useCallback(
        file => {
            dispatch(FJActionImageExtender.uploadImageAction(file));
        },
        [dispatch],
    );
    const _gotoBack = useCallback(() => {
        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
        dispatch(setSliceMobileGenerateSuccessPreviewIndex(0));
    }, [dispatch]);
    const onRestoreMore = useCallback(
        file => {
            dispatch(FJActionImageExtender.uploadImageAction(file));
            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            dispatch(setSliceMobileGenerateSuccessPreviewIndex(0));
        },
        [dispatch],
    );

    const isUploadImage = !!uploadImageInfo?.src;
    const title = 'ai-image-extender-colorful',
        description = 'select-from-a-variety-of-ratios-and-unleash-your-creativity',
        uploadText = 'upload-image';
    return (
        <>
            {!isUploadImage && (
                <FJMobileDefaultPreview
                    title={title}
                    description={description}
                    uploadText={uploadText}
                    uploadImg={uploadImg}
                    videoSrc={FJConfig.notImageBoxVideoUrl}
                />
            )}
            {isUploadImage && (
                <>
                    <FJMobileImageExtenderCreationContainer />
                    <FJMobileImageExtenderEditContainer />
                    <FJMobileGenerateSuccessfulContainer
                        gotoBack={_gotoBack}
                        onReEdit={onRestoreMore}
                        previewList={creationList}
                        gotoBackText={FJLocalStore._('back')}
                        reEditText={FJLocalStore._('extend-more')}
                        imageRect={boardSize}
                    />
                </>
            )}
            <FJMobileHistoryContainer />
        </>
    );
};

export default FJMobileImageExtender;
